export default __webpack_public_path__ + "static/media/NP_logo.b5d6e670.png";